import React, { useState } from 'react';
import { Form, Modal, Button, Spinner } from 'react-bootstrap';
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function ChangePasswordModal({show, handleClose, changePassword}) {
    const [isNewHidden, setNewHidden] = useState(true);
    const [isConfirmHidden, setConfirmHidden] = useState(true);

    const validationSchema = Yup.object().shape({
        password: Yup.string().required('Required'),
        confirmPassword: Yup.string().min(8, 'Password must be atleast 8 characters').required('Required')
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
    });

    return (
        <Modal 
            show={show} 
            size="lg" 
            onHide={handleClose} 
            centered
            className='max-heighted-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: ''
                }}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {changePassword(values, setSubmitting)}}
            >
                {({
                    values,
                    handleChange,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <Form onSubmit={handleSubmit} className='forms'>
                        <Modal.Body className='custom-scrollbar'>
                            <div className='icon-field'>
                                <Form.Label>New Password</Form.Label>
                                <Form.Control 
                                    type={isNewHidden ? 'password' : 'text'}
                                    name='password'  
                                    placeholder='Enter new password'
                                    value={values.password}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                                <ErrorMessage name='password' component='p' className='error-message' />
                                { isNewHidden
                                    ? <AiOutlineEyeInvisible 
                                        size={25} 
                                        className='icon-btn form-text' 
                                        onClick={() => setNewHidden(!isNewHidden)} 
                                        />
                                    : <AiOutlineEye 
                                        size={25} 
                                        color='#ED008C' 
                                        className='icon-btn form-text' 
                                        onClick={() => setNewHidden(!isNewHidden)} 
                                        />
                                }
                            </div>
                            <div className='icon-field'>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control 
                                    type={isConfirmHidden ? 'password' : 'text'}
                                    name='confirmPassword'  
                                    placeholder='Enter new password'
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                                <ErrorMessage name='confirmPassword' component='p' className='error-message' />
                                { isConfirmHidden
                                    ? <AiOutlineEyeInvisible 
                                        size={25} 
                                        className='icon-btn form-text' 
                                        onClick={() => setConfirmHidden(!isConfirmHidden)} 
                                        />
                                    : <AiOutlineEye 
                                        size={25} 
                                        color='#ED008C'
                                        className='icon-btn form-text' 
                                        onClick={() => setConfirmHidden(!isConfirmHidden)} 
                                        />
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' type='button' size='sm' onClick={handleClose} disabled={isSubmitting}>
                                Cancel
                            </Button>
                            <Button variant='primary' type='submit' size='sm' disabled={isSubmitting}>
                                Change Password 
                                {
                                    isSubmitting &&
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className='ms-2'
                                    />
                                }
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}
